import { LoginRestriction } from "../../../data/models";
export class LoginControlHelper {
    constructor() {
        this.validatorForLoginControl = {
            [LoginRestriction.All]: (isUserLoggedIn) => true,
            [LoginRestriction.LoggedInOnly]: (isUserLoggedIn) => isUserLoggedIn,
            [LoginRestriction.LoggedOutOnly]: (isUserLoggedIn) => !isUserLoggedIn
        };
    }
    static get instance() {
        if (!LoginControlHelper._instance) {
            LoginControlHelper._instance = new LoginControlHelper();
        }
        return LoginControlHelper._instance;
    }
    validate(item, isUserLoggedIn) {
        return item.LoginControl
            ? this.validatorForLoginControl[item.LoginControl](isUserLoggedIn)
            : this.validatorForLoginControl[LoginRestriction.All](isUserLoggedIn);
    }
}
//# sourceMappingURL=LoginControlHelper.js.map